module.exports = __webpack_public_path__ + "img/IND-A-1-II.c06284bf.png";